<template>
  <div class="manager-filter">
    <div v-show="selected_manager" class="selected-manager">
      <div class="name">{{ selected_manager && selected_manager.name }}</div>
      <div class="deselect" @click="deselect()">
        <i class="fas fa-times"></i>
      </div>
    </div>
    <div v-show="!selected_manager">
      <input class="manager-query-input"
             type="text"
             placeholder="Filter by manager"
             v-model="query"
             @keypress.enter="autoPick()"
             @keypress.down="addPreselectOffset(1)"
             @keypress.up="addPreselectOffset(-1)"
             @click="query ? search() : null"
      >
      <div v-if="results && results.length > 0" class="search-results" :class="{'no-mouse-hover': mouse_hover}">
        <div @mousemove="resultMouseHover(key)" @click="pickManager(result.id)" class="result" v-for="(result, key) in results" :class="{'hovered' : key === preselect_offset && mouse_hover}">
          {{ result.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

export default {
  created() {
    this.loadFromCache()
  },
  mounted() {
    let div = document.getElementsByClassName('manager-filter')[0]
    div.style.width = div.offsetWidth + 'px'
    div.addEventListener('mouseenter', () => this.mouse_over = true)
    div.addEventListener('mouseleave', () => this.mouse_over = false)
    document.addEventListener('click', () => {
      if (!this.mouse_over) {
        this.results = null
      }
    })
    document.getElementsByClassName('manager-query-input')[0].addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        this.results = null
        this.query = null
      }
      if (e.keyCode == 38) {
        this.addPreselectOffset(-1)
      }
      if (e.keyCode == 40) {
        this.addPreselectOffset(1)
      }
    })

    this.selected_manager = this.cached_manager
  },
  data() {
    return {
      mouse_over: false,
      query: null,
      results: null,
      selected_manager: null,
      preselect_offset: 0,
      mouse_hover: true,
      cached_manager: null,
    }
  },
  watch: {
    query(value) {
      this.searchDebounced()
    },
    selected_manager(value) {
      this.$root.$emit('ManagerFilter::selected-manager', value)
    }
  },
  methods: {
    searchDebounced: _.debounce(function () {
      this.search()
    }, 300),
    search() {
      if (!this.query || this.query == '') {
        this.results = null
        return
      }
      this.axios.get('/n/managers?&query=' + this.query).then(response => {
        this.results = response.data.data
        this.preselect_offset = 0
      })
    },
    autoPick() {
      if (this.results && this.results.length > 0) {
        this.pickManager(this.results[this.preselect_offset].id)
      }
    },
    pickManager(id) {
      this.selected_manager = _.find(this.results, r => r.id === id)
      this.query = null
      this.preselect_offset = 0
      this.mouse_hover = true
      this.cacheManager()
    },
    cacheManager() {
      window.localStorage.setItem('selected_manager', JSON.stringify(this.selected_manager))
    },
    loadFromCache() {
      let manager = window.localStorage.getItem('selected_manager')
      if (manager) {
        this.cached_manager = JSON.parse(manager)
      }
    },
    removeCache() {
      window.localStorage.removeItem('selected_manager')
    },
    deselect() {
      this.selected_manager = null
      this.removeCache()
      this.$nextTick(() => {
        document.getElementsByClassName('manager-query-input')[0].focus()
      })
    },
    addPreselectOffset(n) {
      this.preselect_offset += n
      this.mouse_hover = true
      if (!this.results) {
        this.preselect_offset = 0
        return
      }
      if (this.preselect_offset < 0) {
        this.preselect_offset = 0
        return
      }
      if (this.preselect_offset > this.results.length - 1) {
        this.preselect_offset = this.results.length - 1
        return
      }
    },
    resultMouseHover(key) {
      this.mouse_hover = false
      this.preselect_offset = key
    }
  }
}
</script>
<style lang="scss">
.manager-filter {
  margin-left: 24px;
  flex-grow: 1;
  position: relative;
  display: flex;
  justify-content: end;

  .selected-manager {
    display: flex;
    background: #FF7800;
    border-radius: 40px;
    padding: 0px 8px;
    padding-top: 2px;
    padding-bottom: 0px;
    width: max-content;
    height: fit-content;


    .name {
      color: white;
      margin-right: 4px;
    }

    .deselect {
      color: white;
      cursor: pointer;

      .fas {
        font-weight: 600;
        font-size: 1rem;
        margin-top: 4px !important;
        margin-bottom: -1px;
      }
    }

  }

  input {
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
  }

  .search-results {
    z-index: 9;
    position: absolute;
    width: 100%;
    border: 1px solid #D5D5D5;
    border-radius: 4px;
    background: white;

    .result {
      padding: 4px;
      cursor: pointer;

      &.hovered {
        background: #F2F2F2;
      }
    }
  }

  .search-results:not(.no-mouse-hover) {
    .result {
      &:hover {
        background: #F2F2F2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/filter-by-manager.vue